import Vue from "vue";
import VueRouter from "vue-router";
import wish from "../views/wish/list";
import wishDetail from "../views/wish/detail";
import fruit from "../views/fruit/list";
import fruitDetail from "../views/fruit/detail";
import release from "../views/release/release";
import protocol from "../views/protocol/protocol";
import releaseStory from "../views/release/story";
import update from "../views/update/update";
import myprivate from "../views/myprivate/list";
import privateDetail from "../views/myprivate/detail";
import bindingMobile from "../views/login/bindingMobile";
import mine from "../views/mine/mine";
import edit from "../views/edit/edit";
import comments from "../views/comments/comments";
import rank from "../views/rank/rank";
import register from "../views/login/register";
import login from "../views/login/login";
import loading from "../views/loading/index";

Vue.use(VueRouter);
const routes = [
  {
    path: "/wish",
    component: wish,
    meta: {
      title: "心愿互动",
      keepAlive: true,
      isBack: false,
    },
  },

  {
    path: "/wishDetail",
    component: wishDetail,
    meta: {
      title: "心愿详情",
      keepAlive: false,
    },
  },
  {
    path: "/fruit",
    component: fruit,
    meta: {
      title: "成果展示",
      keepAlive: true,
      isBack: false,
    },
  },

  {
    path: "/fruitDetail",
    component: fruitDetail,
    meta: {
      title: "成果详情",
      keepAlive: false,
    },
  },
  {
    path: "/release",
    component: release,
    meta: {
      title: "发布心愿",
      keepAlive: true,
      isBack: false,
    },
  },
  {
    path: "/releaseStory",
    component: releaseStory,
    meta: {
      title: "发布圆梦故事",
      keepAlive: true,
      isBack: false,
    },
  },
  {
    path: "/protocol",
    component: protocol,
    meta: {
      title: "用户隐私条款和免责声明",
      keepAlive: false,
    },
  },
  {
    path: "/update",
    component: update,
    meta: {
      title: "更新进度",
      keepAlive: false,
    },
  },
  {
    path: "/myprivate",
    component: myprivate,
    meta: {
      title: "私信列表",
      keepAlive: false,
    },
  },
  {
    path: "/privateDetail",
    component: privateDetail,
    meta: {
      title: "私信",
      keepAlive: false,
    },
  },
  {
    path: "/register",
    component: register,
    meta: {
      title: "认证",
      keepAlive: false,
    },
  },
  {
    path: "/login",
    component: login,
    meta: {
      title: "登录",
      keepAlive: false,
    },
  },
  {
    path: "/bindingMobile",
    component: bindingMobile,
    meta: {
      title: "绑定手机号",
      keepAlive: false,
    },
  },
  {
    path: "/mine",
    component: mine,
    meta: {
      title: "我的",
      keepAlive: false,
    },
  },
  {
    path: "/edit",
    component: edit,
    meta: {
      title: "我的资料",
      keepAlive: false,
    },
  },
  {
    path: "/comments",
    component: comments,
    meta: {
      title: "评论",
      keepAlive: false,
    },
  },
  {
    path: "/rank",
    component: rank,
    meta: {
      title: "排行榜",
      keepAlive: false,
    },
  },
  {
    path: "/loading",
    component: loading,
    meta: {
      title: "正在进入",
      keepAlive: false,
    },
  },
];
const router = new VueRouter({
  mode: "history",
  routes,
});
router.beforeEach((to, from, next) => { 
  document.title = to.meta.title;
  var i = document.createElement('iframe');
  i.src = '//m.baidu.com/favicon.ico';
  i.style.display = 'none';
  i.onload = function() {
    setTimeout(function(){
      i.remove();
  }, 9)
}
document.body.appendChild(i);


  // console.log(from);
  var isInApp = JSON.stringify(navigator.appVersion).indexOf("pdmiryun")>0;
  if (isInApp&& localStorage.getItem("uid") == null && to.path != "/loading") {
    localStorage.setItem("_url", to.fullPath);
    next({ path: "/loading", replace: true });
  } else {
    next();
  }
  if (from.path === "/" || from.path === "/loading") {
    localStorage.setItem("isFirstPage", "1");
  } else {
    localStorage.setItem("isFirstPage", "0");
  }
});



export default router;
